import { LegalPage, type LegalSection } from '@/components/legal/legal-page';

const sections: readonly LegalSection[] = [
  {
    title: 'Delete from the app',
    body: [
      'Sign in, open Me, choose Account, then select Delete account. Review the warning and confirm. Deletion begins immediately and signs you out when complete.',
      'If you are the only owner of a club, ownership is transferred to an existing club admin or member when possible. If the club has no other members, your membership is removed and the empty club record remains available for platform administration.',
    ],
  },
  {
    title: 'What deletion removes',
    body: [
      'Deletion removes your authentication account, profile and profile photo, club memberships, friendships, event registrations and check-ins, attendee-form answers, contact records, notification tokens and reminders, connected-service records, routes, and account-owned uploads. Events you created are deleted when they have no other member activity; shared events remain for those members with your creator attribution removed.',
      'Limited de-identified operational or security records may remain where required by law or needed to investigate abuse, fraud, or security incidents.',
    ],
  },
  {
    title: 'Request help without the app',
    body: [
      'Email ajay.koenig@gmail.com from the address attached to your 6am account with the subject “Delete my 6am account.” We will verify account ownership before processing the request and will not ask for your password.',
    ],
  },
];

export default function AccountDeletionScreen() {
  return (
    <LegalPage
      actions={[
        { href: '/(public)/sign-in', label: 'Sign in to delete account' },
        {
          href: 'mailto:ajay.koenig@gmail.com?subject=Delete%20my%206am%20account',
          label: 'Email deletion request',
          variant: 'secondary',
        },
      ]}
      intro="Delete your 6am account and associated data from the app or request help by email."
      sections={sections}
      title="Account deletion"
      updatedAt="22 July 2026"
    />
  );
}
